export default __webpack_public_path__ + "static/media/Background_00070.e517efba.png";